export default __webpack_public_path__ + "static/media/avatar_dragon7.e1cc4992.mp3";